const regexPhone =
  /^[+]?[0-9]{0,3}[-\s.]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/i;

export interface PhoneValidation {
  empty: boolean;
  valid: boolean;
}

export function validatePhone(phone = ''): PhoneValidation {
  const empty = phone === '';
  const valid = regexPhone.test(phone);
  return { empty, valid };
}
